import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/firestore";
/*
const app = firebase.initializeApp({
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_CENTER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
}); */

const app = firebase.initializeApp({
  apiKey: "AIzaSyDKBt_Ixc1khxda60GQWxzYfMDcoSrwYkM",
  authDomain: "larva-89334.firebaseapp.com",
  projectId: "larva-89334",
  storageBucket: "larva-89334.appspot.com",
  messagingSenderId: "933969271593",
  appId: "1:933969271593:web:af4eeda3159811f111f538",
  measurementId: "G-8X0D1G0J91"
});

export const auth = app.auth();
export const database = app.database();
export const firestore = app.firestore();
export default app;
